// extracted by mini-css-extract-plugin
module.exports = {"trigger":"TableDateRangeFilter_trigger__1076x"};